import React, { useState } from "react";
import {
  FiMonitor,
  FiUser,
  FiKey,
  FiCheckCircle,
  FiClock,
  FiCalendar,
  FiHelpCircle,
  FiCpu,
  FiMail,
  FiLock,
} from "react-icons/fi";
import { FaLaptopMedical } from "react-icons/fa";
import UserDashboardLayout from "../../../Components/UserDashboardLayout/UserDashboardLayout";
import "./Help.css";

export default function HelpDashboard() {
  const [activeIndex, setActiveIndex] = useState(null);
  const toggleAccordion = (index) =>
    setActiveIndex(activeIndex === index ? null : index);

  const sections = [
    {
      title: (
        <>
          <FiMonitor className="icon" /> SPCAD – Specialized CAD Plugin
        </>
      ),
      content: (
        <p>
          SPCAD enhances your CAD experience with advanced functionalities for
          terrain analysis, land development, and cartography. For a full guide,
          visit{" "}
          <a
            href="https://help.cadomation.com/spcad/docs/spcadhelp/trials-licences/license-management/"
            target="_blank"
            rel="noreferrer"
          >
            License Management
          </a>
          .
        </p>
      ),
    },
    {
      title: (
        <>
          <FiUser className="icon" /> Why Log in to the Web Dashboard?
        </>
      ),
      content: (
        <ul>
          <li>
            <strong>Check Machine Attachments</strong> – View linked machines
            per license.
          </li>
          <li>
            <strong>Troubleshoot Issues</strong> – Identify license assignment
            errors.
          </li>
          <li>
            <strong>Monitor License Usage</strong> – Track active/expired
            licenses.
          </li>
          <li>
            <strong>Identify Ownership</strong> – See who is using which
            license.
          </li>
          <li>
            <strong>Detach Machines</strong> – Remove devices when needed.
          </li>
        </ul>
      ),
    },
    {
      title: (
        <>
          <FiKey className="icon" /> Managing Licenses & Machines
        </>
      ),
      content: (
        <ul>
          <li>
            <strong>Max 5 Machines</strong> – Only 5 per license at a time.
          </li>
          <li>
            <strong>Adding New Machines</strong> – Remove another if already 5
            attached.
          </li>
          <li>
            <strong>Force Logout</strong> – User logged out after closing CAD if
            removed mid-use.
          </li>
        </ul>
      ),
    },
    {
      title: (
        <>
          <FiCheckCircle className="icon" /> What You See in the Dashboard
        </>
      ),
      content: (
        <ul>
          <li>
            <FiKey /> <strong>License ID</strong> – Unique identifier.
          </li>
          <li>
            <FiMonitor /> <strong>Product in Use</strong> – Active CAD product.
          </li>
          <li>
            <FiUser /> <strong>Last User</strong> – Last accessed by.
          </li>
          <li>
            <FiCheckCircle /> <strong>Status</strong> – Assigned / Available.
          </li>
          <li>
            <FiClock /> <strong>Last Seen</strong> – Activity timestamp.
          </li>
          <li>
            <FiCalendar /> <strong>Created & Expiration</strong> – Duration.
          </li>
        </ul>
      ),
    },
    {
      title: (
        <>
          <FiCpu className="icon" /> Managing Attached Machines
        </>
      ),
      content: (
        <ul>
          <li>
            <FaLaptopMedical className="icon orange" /> Click{" "}
            <strong>"View Attached Machines"</strong> to see linked devices.
          </li>
          <li>If 5 machines are attached, remove one before adding another.</li>
          <li>
            To remove, click <strong>"Remove"</strong>. If user is active,
            logout applies when CAD closes.
          </li>
        </ul>
      ),
    },
    {
      title: (
        <>
          <FiLock className="icon" /> Changing Your Password
        </>
      ),
      content: (
        <p>
          If you want to change your password, you must first{" "}
          <strong>log out</strong> of the User Dashboard. Then go to the{" "}
          <strong>Forgot Password</strong> option on the login page. Follow the
          steps to reset and set your <strong>new password</strong>.
        </p>
      ),
    },
  ];

  return (
    <div>
      <UserDashboardLayout />
      <div className="content-page-bg">
        <div className="content-page">
          <div className="content">
            <div className="help-page">
              <h2 className="page-title">User Guide</h2>
              <div className="help-wrapper">
                <div className="accordion">
                  {sections.map((section, index) => (
                    <div className="accordion-item" key={index}>
                      <button
                        className={`accordion-header ${
                          activeIndex === index ? "active" : ""
                        }`}
                        onClick={() => toggleAccordion(index)}
                      >
                        {section.title}
                        <span className="arrow">
                          {activeIndex === index ? "−" : "+"}
                        </span>
                      </button>
                      {activeIndex === index && (
                        <div className="accordion-content">
                          {section.content}
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Support Card */}
                <div className="support-card">
                  <h3>
                    <FiHelpCircle className="icon" /> Need Help?
                  </h3>
                  <p>
                    We're here to help with product questions or technical support.
                    Visit{" "}
                    <a
                      href="https://cadomation.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <strong>our website</strong>
                    </a>{" "}
                    for more information or resources.
                  </p>
                  <button
                    className="support-btn"
                    onClick={() =>
                      (window.location.href = "mailto:support@cadomation.com")
                    }
                  >
                    <FiMail /> Contact Support
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
